import React from 'react';
import { Box, Button } from '@mui/material';
import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import { useTranslation } from 'react-i18next';
import NextContainerSearch from './NextContainerSearch';

export default function OperationNavigationBar({
  canGoPrevious,
  canGoNext,
  onPrevious,
  onNext,
  options,
  onSearchContainer,
  onSelectContainer,
}) {
  const { t } = useTranslation();

  return (
    <Box sx={{
      display: 'flex',
      flexDirection: 'column',
      gap: 1,
      width: '100%',
    }}
    >
      <Box sx={{ width: '100%' }}>
        <NextContainerSearch
          options={options}
          onSearchContainer={onSearchContainer}
          onSelectContainer={onSelectContainer}
        />
      </Box>
      <Box sx={{
        display: 'flex',
        gap: 1,
        width: '100%',
      }}
      >
        <Button
          variant="outlined"
          onClick={onPrevious}
          disabled={!canGoPrevious}
          startIcon={<ArrowBackIosNewIcon />}
          sx={{
            flex: 1,
            px: { xs: 1.5, sm: 2 },
            whiteSpace: 'nowrap',
            color: 'text.secondary',
            borderColor: 'grey.400',
            '&:hover': {
              borderColor: 'grey.500',
              backgroundColor: 'grey.50',
            },
          }}
        >
          {t('inventory_item.previous')}
        </Button>
        <Button
          variant="outlined"
          onClick={onNext}
          disabled={!canGoNext}
          endIcon={<ArrowForwardIosIcon />}
          sx={{
            flex: 1,
            px: { xs: 1.5, sm: 2 },
            whiteSpace: 'nowrap',
            color: 'text.secondary',
            borderColor: 'grey.400',
            '&:hover': {
              borderColor: 'grey.500',
              backgroundColor: 'grey.50',
            },
          }}
        >
          {t('inventory_item.next')}
        </Button>
      </Box>
    </Box>
  );
}
